import { Box, Text } from '@factorialco/deprecated-design-system'
import { Icon } from '@factorialco/factorial-one-react'
import { LockLocked } from '@factorialco/factorial-one-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { Element } from 'modules/forms/lib/Element'
import { Form } from 'modules/forms/lib/Form'

type Props = {
  element: Element
  form: Form
}

export const ElementPreview = ({ element, form }: Props) => {
  const section = element.sectionId ? form.getElement(element.sectionId) : false
  const position = section
    ? `${section.position + 1}.${element.position + 1}`
    : element.position + 1
  const isMandatory = element?.mandatory ?? false
  const elementType = element.getType()

  return (
    <Box gap="s6" justifyContent="center" paddingY="s32">
      <Box justifyContent="spaceBetween" flexDirection="row" padding="s6">
        <Box flexDirection="row" gap="s4" alignItems="center">
          <Icon icon={element?.getIcon()} />
          <Text size="200" weight="medium">
            {elementType === 'section'
              ? i18n.t('forms.editor.section_position_title', { position: position })
              : i18n.t('forms.editor.question_position_title', { position: position })}
          </Text>
          {isMandatory && (
            <Text size="200" weight="medium" color="accentBackgroundSolid">
              {'*'}
            </Text>
          )}
        </Box>
        {element.isLocked() && <Icon icon={LockLocked} />}
      </Box>
      <Box
        borderRadius={{ all: 'abs016' }}
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
        padding="s24"
        gap="s8"
      >
        <Box gap="s8">
          <Text size="300" weight="medium" color="textPrimary">
            {element.label}
          </Text>
          <Text size="200">{element.description}</Text>
          {element.getPreviewComponent()}
        </Box>
      </Box>
    </Box>
  )
}
